// extracted by mini-css-extract-plugin
export var blockTitle = "main-module--block-title--d2939";
export var blockTitleLg = "main-module--block-title-lg--7cae3";
export var blockTitleMd = "main-module--block-title-md--73dbc";
export var blockTitleMdM = "main-module--block-title-md-m--efa9a";
export var blockTitleMdS = "main-module--block-title-md-s--542d8";
export var blockTitleSm = "main-module--block-title-sm--6c653";
export var blockTitleXs = "main-module--block-title-xs--00e2e";
export var blue = "main-module--blue--56ffb";
export var blueBg = "main-module--blue-bg--c02e7";
export var btnBlock = "main-module--btn-block--1a90f";
export var dBlue = "main-module--d-blue--03e48";
export var dBlueBg = "main-module--d-blue-bg--d97e9";
export var green = "main-module--green--dd01e";
export var greenBg = "main-module--green-bg--97095";
export var icon = "main-module--icon--0ae24";
export var mainBtn = "main-module--main-btn--57f41";
export var sec = "main-module--sec--4cccf";